//Cache
let cache = {
    sessionID: '',
    productitle: 'Star Map',
    productid: 33043245793332,
    details: {
        orientation: 'portrait',
        size: '4x6',
        frame: 'noframe',
        layout: 'standardportrait',
        date: {
            minute: 0,
            hour: 22,
            day: new Date().getDate(),
            month: new Date().getMonth()+1,
            year: new Date().getFullYear(),
            addtime: false
        },
        location: [0,52,0],
        locationfull: {
            town: null,
            county: 'London',
            country: 'United Kingdom'
        },
        backgroundcolour: '#000000',
        mapcolour: '#000000',
        constellationnames: true,
        constellationlines: true,
        planets: true,
        gridlines: true,
        truestarcolour: true,
        text: [
            {
                family: 'Futura',
                color: '#FFFFFF',
                size: 12,
                options: {
                  weight: 600
                },
                value: 'Under These Stars'
            },
            {
                family: 'Futura Light',
                color: '#FFFFFF',
                size: 10,
                options: {
                  weight: 400
                },
                value: ''
            },
            {
                family: 'Futura Light',
                color: '#FFFFFF',
                size: 10,
                options: {
                  weight: 400
                },
                value: '12th September 2022'
            },
            {
                family: 'Futura Light',
                color: '#FFFFFF',
                size: 10,
                options: {
                  weight: 400
                },
                value: `51° 30' 25"N 0° 7' 39"W`
            }
        ]
    }
};

let config = {
    disableAnimations: true,
    width: 0,           // Default width, 0 = full parent element width; 
    // height is determined by projection
    projection: "orthographic",    // Map projection used: see below
    projectionRatio: null,   // Optional override for default projection ratio
    transform: "equatorial", // Coordinate transformation: equatorial (default),
    // ecliptic, galactic, supergalactic
    center: null,       // Initial center coordinates in set transform
    // [longitude, latitude, orientation] all in degrees 
    // null = default center [0,0,0]
    orientationfixed: true,  // Keep orientation angle the same as center[2]
    geopos: null,       // optional initial geographic position [lat,lon] in degrees, 
    // overrides center
    follow: "zenith",   // on which coordinates to center the map, default: zenith, if location enabled, 
    // otherwise center
    zoomlevel: null,    // initial zoom level 0...zoomextend; 0|null = default, 1 = 100%, 0 < x <= zoomextend
    zoomextend: 10,     // maximum zoom level
    adaptable: true,    // Sizes are increased with higher zoom-levels
    interactive: false,  // Enable zooming and rotation with mousewheel and dragging
    form: false,         // Display form for interactive settings. Needs a div with
    // id="celestial-form", created automatically if not present
    location: false,    // Display location settings. Deprecated, use formFields below
    formFields: {
        "location": true,  // Set visiblity for each group of fields with the respective id
        "general": true,
        "stars": true,
        "dsos": true,
        "constellations": true,
        "lines": true,
        "other": true,
        "download": false
    },
    advanced: false,     // Display fewer form fields if false 
    daterange: [],      // Calender date range; null: displaydate-+10; [n<100]: displaydate-+n; [yr]: yr-+10; 
    // [yr, n<100]: [yr-n, yr+n]; [yr0, yr1]  
    controls: false,     // Display zoom controls
    lang: "",           // Global language override for names, any name setting that has the chosen language available
    // Default: desig or empty string for designations, other languages as used anywhere else
    culture: "",        // Source of constellations and star names, default "iau", other: "cn" Traditional Chinese
    container: 'starmapcontainer',   // ID of parent element, e.g. div, null = html-body
    datapath: "https://cdn.jsdelivr.net/gh/tman16/fonts/",  // Path/URL to data files, empty = subfolder 'data'
    stars: {
        show: true,    // Show stars
        limit: 6,      // Show only stars brighter than limit magnitude
        colors: true,  // Show stars in spectral colors, if not use default color
        style: { fill: "#ffffff", opacity: 1 }, // Default style for stars
        designation: false, // Show star names (Bayer, Flamsteed, Variable star, Gliese or designation, 
        // i.e. whichever of the previous applies first); may vary with culture setting
        designationType: "desig",  // Which kind of name is displayed as designation (fieldname in starnames.json)
        designationStyle: { fill: "#ddddbb", font: "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif", align: "left", baseline: "top" },
        designationLimit: 2.5,  // Show only names for stars brighter than nameLimit
        propername: false,   // Show proper name (if present)
        propernameType: "name", // Languge for proper name, default IAU name; may vary with culture setting 
        // (see list below of languages codes available for stars)
        propernameStyle: { fill: "#ddddbb", font: "13px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif", align: "right", baseline: "bottom" },
        propernameLimit: 1.5,  // Show proper names for stars brighter than propernameLimit
        size: 10,       // Maximum size (radius) of star circle in pixels
        exponent: -0.28, // Scale exponent for star size, larger = more linear
        data: 'stars.6.json' // Data source for stellar data, 
        // number indicates limit magnitude
    },
    dsos: {
        show: false,    // Show Deep Space Objects 
        limit: 6,      // Show only DSOs brighter than limit magnitude
        colors: true,  // // Show DSOs in symbol colors if true, use style setting below if false
        style: { fill: "#cccccc", stroke: "#cccccc", width: 2, opacity: 1 }, // Default style for dsos
        names: false,   // Show DSO names
        namesType: "name",  // Type of DSO ('desig' or language) name shown
        // (see list below for languages codes available for dsos)
        nameStyle: {
            fill: "#cccccc", font: "11px Helvetica, Arial, serif",
            align: "left", baseline: "top"
        }, // Style for DSO names
        nameLimit: 6,  // Show only names for DSOs brighter than namelimit
        size: null,    // Optional seperate scale size for DSOs, null = stars.size
        exponent: 1.4, // Scale exponent for DSO size, larger = more non-linear
        data: 'dsos.bright.json', // Data source for DSOs, 
        // opt. number indicates limit magnitude
        symbols: {  //DSO symbol styles, 'stroke'-parameter present = outline
            gg: { shape: "circle", fill: "#ff0000" },          // Galaxy cluster
            g: { shape: "ellipse", fill: "#ff0000" },         // Generic galaxy
            s: { shape: "ellipse", fill: "#ff0000" },         // Spiral galaxy
            s0: { shape: "ellipse", fill: "#ff0000" },         // Lenticular galaxy
            sd: { shape: "ellipse", fill: "#ff0000" },         // Dwarf galaxy
            e: { shape: "ellipse", fill: "#ff0000" },         // Elliptical galaxy
            i: { shape: "ellipse", fill: "#ff0000" },         // Irregular galaxy
            oc: {
                shape: "circle", fill: "#ffcc00",
                stroke: "#ffcc00", width: 1.5
            },             // Open cluster
            gc: { shape: "circle", fill: "#ff9900" },          // Globular cluster
            en: { shape: "square", fill: "#ff00cc" },          // Emission nebula
            bn: {
                shape: "square", fill: "#ff00cc",
                stroke: "#ff00cc", width: 2
            },               // Generic bright nebula
            sfr: {
                shape: "square", fill: "#cc00ff",
                stroke: "#cc00ff", width: 2
            },               // Star forming region
            rn: { shape: "square", fill: "#00ooff" },          // Reflection nebula
            pn: { shape: "diamond", fill: "#00cccc" },         // Planetary nebula 
            snr: { shape: "diamond", fill: "#ff00cc" },         // Supernova remnant
            dn: {
                shape: "square", fill: "#999999",
                stroke: "#999999", width: 2
            },               // Dark nebula grey
            pos: {
                shape: "marker", fill: "#cccccc",
                stroke: "#cccccc", width: 1.5
            }              // Generic marker
        }
    },
    planets: {  //Show planet locations, if date-time is set
        show: true,
        // List of all objects to show
        which: ["sol", "mer", "ven", "ter", "lun", "mar", "jup", "sat", "ura", "nep"],
        // Font styles for planetary symbols
        symbols: {  // Character and color for each symbol in 'which' above (simple circle: \u25cf), optional size override for Sun & Moon
            "sol": { symbol: "\u2609", letter: "Su", fill: "#fa7d0f", fontcolor: '#db7b04', size: 28 },
            "mer": { symbol: "\u263f", letter: "Me", fill: "#cccccc", fontcolor: '#db7b04' },
            "ven": { symbol: "\u2640", letter: "V", fill: "#eeeecc", fontcolor: '#db7b04' },
            "ter": { symbol: "\u2295", letter: "T", fill: "#00ccff", fontcolor: '#db7b04' },
            "lun": { symbol: "\u25cf", letter: "L", fill: "#ffffff", fontcolor: '#db7b04', size: 28 }, // overridden by generated crecent, except letter & size
            "mar": { symbol: "\u2642", letter: "Ma", fill: "#ff6600", fontcolor: '#db7b04' },
            "cer": { symbol: "\u26b3", letter: "C", fill: "#cccccc", fontcolor: '#db7b04' },
            "ves": { symbol: "\u26b6", letter: "Ma", fill: "#cccccc", fontcolor: '#db7b04' },
            "jup": { symbol: "\u2643", letter: "J", fill: "#ffaa33", fontcolor: '#db7b04' },
            "sat": { symbol: "\u2644", letter: "Sa", fill: "#ffdd66", fontcolor: '#db7b04' },
            "ura": { symbol: "\u2645", letter: "U", fill: "#66ccff", fontcolor: '#db7b04' },
            "nep": { symbol: "\u2646", letter: "N", fill: "#6666ff", fontcolor: '#db7b04' },
            "plu": { symbol: "\u2647", letter: "P", fill: "#aaaaaa", fontcolor: '#db7b04' },
            "eri": { symbol: "\u26aa", letter: "E", fill: "#eeeeee", fontcolor: '#db7b04' }
        },
        symbolStyle: {
            fill: "#00ccff", font: "bold 17px 'Lucida Sans Unicode', Consolas, sans-serif",
            align: "center", baseline: "middle"
        },
        symbolType: "disk",  // Type of planet symbol: 'symbol' graphic planet sign, 'disk' filled circle scaled by magnitude
        // 'letter': 1 or 2 letters S Me V L Ma J S U N     
        names: true,          // Show name in nameType language next to symbol
        nameStyle: { fill: "#db7b04", font: "2.5em Centaur, serif", align: "right", baseline: "top" },
        namesType: "en"     // Language of planet name (see list below of language codes available for planets), 
        // or desig = 3-letter designation
    },
    constellations: {
        names: true,      // Show constellation names 
        namesType: "name", // Type of name Latin (iau, default), 3 letter designation (desig) or other language (see list below)
        nameStyle: {
            fill: "#F1CA59", align: "center", baseline: "middle",
            font: ["small-caps 2.5em 'Centaur'"]
        },// ranked constellations
        lines: true,   // Show constellation lines, style below
        lineStyle: { stroke: "#cccccc", width: 1, opacity: 0.6 },
        bounds: false, // Show constellation boundaries, style below
        boundStyle: { stroke: "#cccc00", width: 0.5, opacity: 0.8, dash: [2, 4] }
    },
    mw: {
        show: false,     // Show Milky Way as filled multi-polygon outlines 
        style: { fill: "#000000", opacity: 1 }  // Style for MW layers
    },
    lines: {  // Display & styles for graticule & some planes
        graticule: {
            show: true, stroke: "#cccccc", width: 0.6, opacity: 1,
            // grid values: "outline", "center", or [lat,...] specific position
            lon: { pos: [""], fill: "#eee", font: "10px Helvetica, Arial, sans-serif" },
            // grid values: "outline", "center", or [lon,...] specific position
            lat: { pos: [""], fill: "#eee", font: "10px Helvetica, Arial, sans-serif" }
        },
        equatorial: { show: false, stroke: "#aaaaaa", width: 1.3, opacity: 0.7 },
        ecliptic: { show: false, stroke: "#66cc66", width: 1.3, opacity: 0.7 },
        galactic: { show: false, stroke: "#cc6666", width: 1.3, opacity: 0.7 },
        supergalactic: { show: false, stroke: "#cc66cc", width: 1.3, opacity: 0.7 }
    },
    background: {        // Background style
        fill: cache.details.mapcolour,   // Area fill
        opacity: 1,
        stroke: "#FFFFFF", // Outline
        width: 2
    },
    horizon: {  //Show horizon marker, if location is set and map projection is all-sky
        show: false,
        stroke: "#cccccc", // Line
        width: 1.0,
        fill: "#000000",   // Area below horizon
        opacity: 0.5
    },
    daylight: {  //Show day sky as a gradient, if location is set and map projection is hemispheric
        show: false
    }
};

//Declare options for right menu
let designobj = {
    options: [
        {
            name: 'Size',
            icon: svgsize,
            description: 'Choose from our selection of print sizes. Changing the orientation alters the layout, you can adjust this in the layout tab.',
            variants: [
                {
                    name: 'Size',
                    id: 'size',
                    type: 'select',
                    variations: [
                        {
                            name: 'Orientation',
                            id: 'orientation',
                            options: [
                                {
                                    name: 'Square',
                                    value: 'square'
                                },
                                {
                                    name: 'Portrait',
                                    value: 'portrait'
                                },
                                {
                                    name: 'Landscape',
                                    value: 'landscape'
                                },
                            ]
                        },
                        {
                            name: 'Size',
                            id: 'size',
                            options: [
                                {
                                    name: '6" x 6"',
                                    value: '6x6',
                                    linked: 'square'
                                },
                                {
                                    name: '8" x 8"',
                                    value: '8x8',
                                    linked: 'square'
                                },
                                {
                                    name: '12" x 12"',
                                    value: '12x12',
                                    linked: 'square'
                                },
                                {
                                    name: '16" x 16"',
                                    value: '16x16',
                                    linked: 'square'
                                },
                                {
                                    name: '20" x 20"',
                                    value: '20x20',
                                    linked: 'square'
                                },
                                {
                                    name: '24" x 24"',
                                    value: '24x24',
                                    linked: 'square'
                                },
                                //Portrait
                                {
                                    name: '4" x 6"',
                                    value: '4x6',
                                    linked: 'portrait'
                                },
                                {
                                    name: '5" x 7"',
                                    value: '5x7',
                                    linked: 'portrait'
                                },
                                {
                                    name: '8" x 10"',
                                    value: '8x10',
                                    linked: 'portrait'
                                },
                                {
                                    name: '9" x 12"',
                                    value: '9x12',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A4',
                                    value: 'a4p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '10" x 15"',
                                    value: '10x15',
                                    linked: 'portrait'
                                },
                                {
                                    name: '12" x 15"',
                                    value: '12x15',
                                    linked: 'portrait'
                                },
                                {
                                    name: '12" x 16"',
                                    value: '12x16',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A3',
                                    value: 'a3p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '16" x 20"',
                                    value: '16x20',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A2',
                                    value: 'a2p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '18" x 24"',
                                    value: '18x24',
                                    linked: 'portrait'
                                },
                                {
                                    name: '20" x 30"',
                                    value: '20x30',
                                    linked: 'portrait'
                                },
                                {
                                    name: '24" x 30"',
                                    value: '24x30',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A1',
                                    value: 'a1p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '24" x 36"',
                                    value: '24x36',
                                    linked: 'portrait'
                                },
                                //Landscape
                                {
                                    name: '6" x 4"',
                                    value: '6x4',
                                    linked: 'landscape'
                                },
                                {
                                    name: '7" x 5"',
                                    value: '7x5',
                                    linked: 'landscape'
                                },
                                {
                                    name: '10" x 8"',
                                    value: '10x8',
                                    linked: 'landscape'
                                },
                                {
                                    name: '12" x 9"',
                                    value: '12x9',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A4',
                                    value: 'a4l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '15" x 10"',
                                    value: '15x10',
                                    linked: 'landscape'
                                },
                                {
                                    name: '15" x 12"',
                                    value: '15x12',
                                    linked: 'landscape'
                                },
                                {
                                    name: '16" x 12"',
                                    value: '16x12',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A3',
                                    value: 'a3l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '20" x 16"',
                                    value: '20x16',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A2',
                                    value: 'a2l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '24" x 18"',
                                    value: '24x18',
                                    linked: 'landscape'
                                },
                                {
                                    name: '30" x 20"',
                                    value: '30x20',
                                    linked: 'landscape'
                                },
                                {
                                    name: '30" x 24"',
                                    value: '30x24',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A1',
                                    value: 'a1l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '36" x 24"',
                                    value: '36x24',
                                    linked: 'landscape'
                                },
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: 'Framing',
            icon: svgframe,
            description: 'Choose from our selection of frame finishes.',
            variants: [
                {
                    name: 'Frame',
                    id: 'frame',
                    type: 'select',
                    variations: [
                        {
                            name: 'Frame',
                            id: 'frame',
                            options: [
                                {
                                    name: 'No Frame',
                                    value: 'noframe'
                                },
                                {
                                    name: 'Matt Black',
                                    value: 'mattblack'
                                },
                                {
                                    name: 'Matt Silver',
                                    value: 'mattsilver'
                                },
                                {
                                    name: 'Brushed Copper',
                                    value: 'brushedcopper'
                                },
                                {
                                    name: 'Brushed Champagne Gold',
                                    value: 'brushedchampagnegold'
                                },
                                {
                                    name: 'Brushed Steel',
                                    value: 'brushedsteel'
                                },
                                {
                                    name: 'Polished Silver',
                                    value: 'polishedsilver'
                                },
                                {
                                    name: 'Polished Dark Grey',
                                    value: 'darkpolishedgrey'
                                },
                                {
                                    name: 'Black Oak',
                                    value: 'blackoak'
                                },
                                {
                                    name: 'White Oak',
                                    value: 'whiteoak'
                                },
                                {
                                    name: 'Oak',
                                    value: 'oak'
                                },
                                {
                                    name: 'Wenge',
                                    value: 'wenge'
                                },
                            ]
                        },
                    ]
                }
            ]
        },
        {
            name: 'Location/Date',
            icon: svglocationmarker,
            description: 'Choose a location/date.',
            variants: [
                {
                    name: 'Location',
                    id: 'location',
                    type: 'location',
                },
                {
                    name: 'Date/Time',
                    id: 'date',
                    type: 'date',
                    addtime: {
                        name: 'Add Time?'
                    }
                },
            ]
        },
        {
            name: 'Style/Text',
            icon: svgpalette,
            description: 'Customise the design of the star map such as the background colour or elements displayed on the star map.',
            variants: [
                {
                    name: 'Text Options',
                    id: 'text',
                    type: 'text',
                    variations: [
                        {
                            name: 'Line 1',
                            id: 'text1',
                            moreinfo: {
                                name: 'Text 1',
                                image: `https://ucarecdn.com/7a6c4676-49d7-4bf4-a4b2-7c4bd925ab4e/starmapexampletext1.jpg`,
                                html: `Enter text to appear on the design.`
                            },
                            examples: [
                                {
                                    category: 'General',
                                    items: ['The night sky', 'Under these stars', 'How the stars appeared on this day', 'The stars aligned', 'The starry night sky', 'Beneath these stars']
                                },
                                {
                                    category: 'Anniversary',
                                    items: ['Our first date', 'The stars aligned', 'Our night sky', 'Our first dance', 'When we said I do', 'happy Anniversary']
                                },
                                {
                                    category: 'Birthday',
                                    items: ['Birthday stars', 'How the stars aligned on the day you were born', 'Happy 18th Birthday', 'Day you were born']
                                },
                                {
                                    category: 'Wedding',
                                    items: ['Under these stars we became husband & wife', 'Forever and always', 'Our first dance', 'When we said I do', 'Day our journey began', 'Our wedding day']
                                },
                                {
                                    category: 'Engagement',
                                    items: ['When you said yes', 'Forever and always', 'We said yes']
                                },
                                {
                                    category: 'Love',
                                    items: ['Our love was written in the stars', 'Our first date', 'I love you to the moon and back', 'How the stars were on...', 'Our first kiss', 'Where it all began', 'Our first Christmas together']
                                },
                                {
                                    category: 'Birth/Christening',
                                    items: ['True star was born', 'This day under the stars, your journey began', 'The heaven above on your Christening', 'Day you were born', 'The day we became three']
                                },
                                //graduation
                            ]
                        },
                        {
                            name: 'Line 2',
                            id: 'text2',
                            moreinfo: {
                                name: 'Text 2',
                                image: `https://ucarecdn.com/b3233833-c673-490a-9dd1-42c33349190c/starmapexampletext2.jpg`,
                                html: `Enter text to appear on the design.`
                            },
                        },
                        {
                            name: 'Line 3',
                            id: 'text3',
                            moreinfo: {
                                name: 'Text 3',
                                image: `https://ucarecdn.com/2dedd649-99ae-429f-ab1c-5f57f0b1a60d/starmapexampletext3.jpg`,
                                html: `Date automatically updates here, you can override the text.`
                            },
                        },
                        {
                            name: 'Line 4',
                            id: 'text4',
                            moreinfo: {
                                name: 'Text 4',
                                image: `https://ucarecdn.com/3cde3a62-e634-4776-81c4-fa290f42a16b/starmapexampletext4.jpg`,
                                html: `Coordinates automatically update when choosing a location, you can override the text.`
                            },
                        },
                    ]
                },
                {
                    name: 'Star Map Options',
                    id: 'starmapoptions',
                    description: 'Select the star map elements. Only selected will be visible on the design.',
                    type: 'checkbox',
                    variations: [
                        {
                            name: 'Constellation Lines',
                            id: 'constellationlines',
                            moreinfo: {
                                name: 'Constellation Lines',
                                image: `https://ucarecdn.com/e4c4c355-9685-48c4-b99b-2437fdbe53f5/starmapexampleconstellationlines.jpg`,
                                html: `Choose whether to include the star constellation lines on the design.`
                            },
                        },
                        {
                            name: 'Constellation Names',
                            id: 'constellationnames',
                            moreinfo: {
                                name: 'Constellation Names',
                                image: `https://ucarecdn.com/ea621d57-dcab-4de0-b3c2-ddf0cdb3256a/starmapexampleconstellationnames.jpg`,
                                html: `Choose whether to include the star constellation names on the design.`
                            },
                        },
                        {
                            name: 'Sun, Moon & Planets',
                            id: 'planets',
                            moreinfo: {
                                name: 'Planets',
                                image: `https://ucarecdn.com/ec2f911a-2252-44e7-abc6-754ff46f61db/starmapexampleplanets.jpg`,
                                html: `Choose whether to include the planets in our solar system on the design.`
                            },
                        },
                        {
                            name: 'Gridlines',
                            id: 'gridlines',
                            moreinfo: {
                                name: 'Gridlines',
                                image: `https://ucarecdn.com/5f47c475-b676-4b76-9f08-7768d1a22a57/starmapexamplegridlines.jpg`,
                                html: `Choose whether to include the gridlines on the design. These are reference lines to help locate stars in the sky.`
                            },
                        },
                        {
                            name: 'True Star Colour',
                            id: 'truestarcolour',
                            moreinfo: {
                                name: 'True Star Colour',
                                image: `https://ucarecdn.com/f04fed31-577d-4f59-9066-16dd3ff2237d/starmapexamplestarcolour.jpg`,
                                html: `All stars will be displayed as white if you turn this off. The spectral colour of the star changes depending on it's temperature, hot stars give off a blue colour whereas cooler stars are red.`
                            },
                        },
                    ]
                },
                {
                    name: 'Colours',
                    id: 'colours',
                    type: 'colourchips',
                    variations: [
                        {
                            name: 'Background Colour',
                            id: 'backgroundcolour',
                            options: [
                                { name: 'Yellow', value: '#efb702' },
                                { name: 'Orange', value: '#dd7742' },
                                { name: 'Red', value: '#d33b3e' },
                                { name: 'Burgundy', value: '#7f1e17' },
                                { name: 'Fuschia', value: '#d95c80' },
                                { name: 'Blush', value: '#e28a84' },
                                { name: 'Pink', value: '#e79dae' },
                                { name: 'Purple', value: '#6b3687' },
                                { name: 'Eggplant', value: '#421d4a' },
                                { name: 'Pigeon', value: '#9eb3ca' },
                                { name: 'Sky Blue', value: '#9ab5d3' },
                                { name: 'Aqua', value: '#9cd0d3' },
                                { name: 'Turquoise', value: '#52aab3' },
                                { name: 'Royal', value: '#294a94' },
                                { name: 'Blue Jack', value: '#153a51' },
                                { name: 'Midnight', value: '#1a1d29' },
                                { name: 'Grey Blue', value: '#3b4555' },
                                { name: 'Aquamarine', value: '#234955' },
                                { name: 'Cobalt Blue', value: '#141646' },
                                { name: 'Mint', value: '#a5cfae' },
                                { name: 'Forest', value: '#437144' },
                                { name: 'Green Bottle', value: '#214231' },
                                { name: 'Khaki', value: '#616451' },
                                { name: 'Cream', value: '#f4e5ce' },
                                { name: 'Old Paper', value: '#d6bfa0' },
                                { name: 'Clay', value: '#b8a998' },
                                { name: 'Brown', value: '#523527' },
                                { name: 'Duty Blue', value: '#556473' },
                                { name: 'Grey', value: '#a4a4a4' },
                                { name: 'Anthracite', value: '#3b3b3c' },
                                { name: 'Black', value: '#000000' },
                                { name: 'White', value: '#FFFFFF' },
                            ]
                        },
                        {
                            name: 'Map Colour',
                            id: 'mapcolour',
                            options: [
                                { name: 'Yellow', value: '#efb702' },
                                { name: 'Orange', value: '#dd7742' },
                                { name: 'Red', value: '#d33b3e' },
                                { name: 'Burgundy', value: '#7f1e17' },
                                { name: 'Fuschia', value: '#d95c80' },
                                { name: 'Blush', value: '#e28a84' },
                                { name: 'Pink', value: '#e79dae' },
                                { name: 'Purple', value: '#6b3687' },
                                { name: 'Eggplant', value: '#421d4a' },
                                { name: 'Pigeon', value: '#9eb3ca' },
                                { name: 'Sky Blue', value: '#9ab5d3' },
                                { name: 'Aqua', value: '#9cd0d3' },
                                { name: 'Turquoise', value: '#52aab3' },
                                { name: 'Royal', value: '#294a94' },
                                { name: 'Blue Jack', value: '#153a51' },
                                { name: 'Midnight', value: '#1a1d29' },
                                { name: 'Grey Blue', value: '#3b4555' },
                                { name: 'Aquamarine', value: '#234955' },
                                { name: 'Cobalt Blue', value: '#141646' },
                                { name: 'Mint', value: '#a5cfae' },
                                { name: 'Forest', value: '#437144' },
                                { name: 'Green Bottle', value: '#214231' },
                                { name: 'Khaki', value: '#616451' },
                                { name: 'Cream', value: '#f4e5ce' },
                                { name: 'Old Paper', value: '#d6bfa0' },
                                { name: 'Clay', value: '#b8a998' },
                                { name: 'Brown', value: '#523527' },
                                { name: 'Duty Blue', value: '#556473' },
                                { name: 'Grey', value: '#a4a4a4' },
                                { name: 'Anthracite', value: '#3b3b3c' },
                                { name: 'Black', value: '#000000' },
                                { name: 'White', value: '#FFFFFF' },
                            ]
                        },
                    ]
                },
            ]
        },
        {
            name: 'Layout',
            icon: svglayout,
            description: 'Select a design layout from the options below, these change depending on orientation of the print.',
            variants: [
                {},//blank update designobj search 'val' without using fixed index 1
                {
                    name: 'Layout',
                    id: 'layout',
                    type: 'radio',
                    variations: [
                        //square
                        {
                            name: 'Standard',
                            value: 'standardsquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(1.20005,0,0,1.20005,-64.9644,-19.4521)"> <circle cx="220.794" cy="139.605" r="92.112"/> </g> <g transform="matrix(1,0,0,1,11.2277,37.624)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.836575,0,0,1,41.8738,57.7497)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.894706,0,0,1,31.107,75.7995)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.648791,0,0,1,76.1934,94.2636)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        {
                            name: 'Square Map',
                            value: 'squaremapsquare',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(1,0,0,1,11.2277,37.624)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.836575,0,0,1,41.8738,57.7497)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.894706,0,0,1,31.107,75.7995)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.648791,0,0,1,76.1934,94.2636)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.947302,0,0,0.947302,50.4251,13.6286)"> <rect x="41.21" y="25.243" width="233.377" height="233.377"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        //portrait
                        {
                            name: 'Standard',
                            value: 'standardportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(1.20005,0,0,1.20005,-64.9644,-19.4521)"> <circle cx="220.794" cy="139.605" r="92.112"/> </g> <g transform="matrix(1,0,0,1,11.2277,37.624)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.836575,0,0,1,41.8738,57.7497)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.894706,0,0,1,31.107,75.7995)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.648791,0,0,1,76.1934,94.2636)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        {
                            name: 'Square Map',
                            value: 'squaremapportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(1,0,0,1,11.2277,37.624)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.836575,0,0,1,41.8738,57.7497)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.894706,0,0,1,31.107,75.7995)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.648791,0,0,1,76.1934,94.2636)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.947302,0,0,0.947302,50.4251,13.6286)"> <rect x="41.21" y="25.243" width="233.377" height="233.377"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        //Landscape
                        {
                            name: 'Standard',
                            value: 'standardlandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(1.20005,0,0,1.20005,-64.9644,-19.4521)"> <circle cx="220.794" cy="139.605" r="92.112"/> </g> <g transform="matrix(1,0,0,1,11.2277,37.624)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.836575,0,0,1,41.8738,57.7497)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.894706,0,0,1,31.107,75.7995)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.648791,0,0,1,76.1934,94.2636)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                        {
                            name: 'Square Map',
                            value: 'squaremaplandscape',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(1,0,0,1,11.2277,37.624)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.836575,0,0,1,41.8738,57.7497)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.894706,0,0,1,31.107,75.7995)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.648791,0,0,1,76.1934,94.2636)"> <rect x="150.809" y="267.183" width="75.926" height="2.876"/> </g> <g transform="matrix(0.947302,0,0,0.947302,50.4251,13.6286)"> <rect x="41.21" y="25.243" width="233.377" height="233.377"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                    ]
                }
            ]
        },
    ]
};

//Design Templates
let layouttemplates = [
    //Square
    {
        name: 'Standard',
        id: 'standardsquare',
        value: 'standardsquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            map: [
                {
                    projection: {
                        id: 'orthographic',
                    },
                    top: 0.09,
                    align: 'center',
                    scale: 0.65,
                },
            ],
            text: [
                {
                    lines: 4,
                    top: 2/3,
                    left: 0.1,
                    width: 0.8,
                    height: 0.3,
                    fonts: ['Futura','Futura Light','Futura Light','Futura Light']
                }
            ]
        },
    },
    {
        name: 'Square Star Map',
        id: 'squaremapsquare',
        value: 'squaremapsquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            additionaloptions: [
                {
                    type: 'sectionbackground',
                    top: 0.15,
                    left: 0.1,
                    width: 0.8,
                    height: 0.9,
                }
            ],
            map: [
                {
                    projection: {
                        id: 'cylindricalEqualArea',
                        ratio: 1.10,
                        scale: 440
                    },
                    top: 0.09,
                    align: 'center',
                    scale: 0.7,
                },
            ],
            text: [
                {
                    lines: 4,
                    top: 2/3,
                    left: 0.1,
                    width: 0.8,
                    height: 0.3,
                    fonts: ['Futura','Futura Light','Futura Light','Futura Light']
                }
            ]
        },
    },
    //Portrait projection: 'cylindricalEqualArea',
    {
        name: 'Standard',
        id: 'standardportrait',
        value: 'standardportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            additionaloptions: [
                {
                    type: 'sectionbackground',
                    top: 0.1,
                    left: 0.1,
                    width: 0.8,
                    height: 0.9,
                }
            ],
            map: [
                {
                    projection: {
                        id: 'orthographic',
                    },
                    top: 0.09,
                    align: 'center',
                    scale: 0.8,
                },
            ],
            text: [
                {
                    lines: 4,
                    top: 2/3,
                    left: 0.1,
                    width: 0.8,
                    height: 0.3,
                    fonts: ['Futura','Futura Light','Futura Light','Futura Light']
                }
            ]
        },
    },
    {
        name: 'Square Star Map',
        id: 'squaremapportrait',
        value: 'squaremapportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            additionaloptions: [
                {
                    type: 'sectionbackground',
                    top: 0.1,
                    left: 0.1,
                    width: 0.8,
                    height: 0.9,
                }
            ],
            map: [
                {
                    projection: {
                        id: 'cylindricalEqualArea',
                        ratio: 1.10,
                        scale: 440
                    },
                    top: 0.09,
                    align: 'center',
                    scale: 0.8,
                },
            ],
            text: [
                {
                    lines: 4,
                    top: 2/3,
                    left: 0.1,
                    width: 0.8,
                    height: 0.3,
                    fonts: ['Futura','Futura Light','Futura Light','Futura Light']
                }
            ]
        },
    },
    //Landscape
    {
        name: 'Standard',
        id: 'standardlandscape',
        value: 'standardlandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            map: [
                {
                    projection: {
                        id: 'orthographic',
                    },
                    top: 0.09,
                    align: 'center',
                    scale: 0.6,
                },
            ],
            text: [
                {
                    lines: 4,
                    top: 2/3,
                    left: 0.1,
                    width: 0.8,
                    height: 0.3,
                    fonts: ['Futura','Futura Light','Futura Light','Futura Light']
                }
            ]
        },
    },
    {
        name: 'Square Star Map',
        id: 'squaremaplandscape',
        value: 'squaremaplandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            additionaloptions: [
                {
                    type: 'sectionbackground',
                    top: 0.1,
                    left: 0.1,
                    width: 0.8,
                    height: 0.9,
                }
            ],
            map: [
                {
                    projection: {
                        id: 'cylindricalEqualArea',
                        ratio: 1.10,
                        scale: 440
                    },
                    top: 0.09,
                    align: 'center',
                    scale: 0.7,
                },
            ],
            text: [
                {
                    lines: 4,
                    top: 2/3,
                    left: 0.1,
                    width: 0.8,
                    height: 0.3,
                    fonts: ['Futura','Futura Light','Futura Light','Futura Light']
                }
            ]
        },
    },
];